import { Avatar } from '@hangar/web-components/core/Avatar';
import { Spinner } from '@hangar/web-components/core/Spinner';
import { Tooltip } from '@ecargo/web-components';
import * as S from './styles/AssignmentButton.style';
import { useTranslation } from '../../hooks/i18n/useTranslation';
import { getUserInitials } from '../../utils/user';
import { AssignmentButtonProps } from './types';

const getAnalystDisplayName = (fullName: string): string => {
    if (!fullName) return '-';
    return fullName.replace(/\s*\([^)]*\)/, '').trim();
};

export const AssignmentButton = ({
    analyst,
    isAssigning = false,
    onAssign,
    assignLabel,
    showToAssignLink = false,
    isNotApplicable = false,
}: AssignmentButtonProps) => {
    const { t } = useTranslation();

    const handleClick = (e: React.MouseEvent) => {
        e.stopPropagation();
        if (!isAssigning && !isNotApplicable && onAssign) {
            onAssign();
        }
    };

    const handleDisabledClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    const renderAssignLink = (showSpinner: boolean = true) => {
        if (isNotApplicable) {
            return (
                <Tooltip title={t('flightChangesCases.assignDisabledTooltip')}>
                    <span onClick={handleDisabledClick}>
                        <S.AssignLink disabled={true} data-testid="assign-button">
                            {assignLabel || t('flightChangesCases.assign')}
                        </S.AssignLink>
                    </span>
                </Tooltip>
            );
        }

        return (
            <S.AssignLink
                onClick={handleClick}
                disabled={isAssigning}
                data-testid="assign-button"
            >
                {showSpinner && isAssigning ? (
                    <Spinner colorMode="standard" id="compact" size="compact" />
                ) : (
                    assignLabel || t('flightChangesCases.assign')
                )}
            </S.AssignLink>
        );
    };

    if (analyst?.name) {
        const displayName = getAnalystDisplayName(analyst.name);
        const initialsLabel = getUserInitials(displayName);

        const avatar = (
            <S.AnalystAvatarWrap>
                <Avatar
                    className="fc-assignment-avatar"
                    size="normal"
                    initials={{ color: 'soft', label: initialsLabel }}
                />
            </S.AnalystAvatarWrap>
        );

        if (showToAssignLink) {
            return (
                <S.AvatarWithLinkContainer>
                    <Tooltip title={displayName}>
                        <span>{avatar}</span>
                    </Tooltip>
                    {renderAssignLink()}
                </S.AvatarWithLinkContainer>
            );
        }

        return (
            <Tooltip title={displayName}>
                <span>{avatar}</span>
            </Tooltip>
        );
    }

    return renderAssignLink();
};

export default AssignmentButton;
